import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import { BsSearch } from "react-icons/bs";

const Search = () => {
  return (
    <Container>
      <Row className="pt-4">
        <Col>
          <Form.Group as={Col}>
            <InputGroup>
              <InputGroup.Text id="inputGroupPrepend">
                <BsSearch />
              </InputGroup.Text>
              <Form.Control type="text" placeholder="Search" aria-describedby="inputGroupPrepend" name="username" />
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
    </Container>
  );
};

export default Search;
